import type { MyDayPlans } from "./my-day.ts";
import type { WeeklyReviewReminder, WeeklyReviewState } from "./weekly-review.ts";
import type { InboxTriageState } from "./inbox-triage.ts";

export interface PlanningStateInitial {
  myDayPlans: MyDayPlans;
  weeklyReview: WeeklyReviewState | null;
  inboxTriage: InboxTriageState | null;
  weeklyReviewReminder: WeeklyReviewReminder;
}

export class PlanningState {
  myDayPlans: MyDayPlans;
  weeklyReview: WeeklyReviewState | null;
  inboxTriage: InboxTriageState | null;
  weeklyReviewReminder: WeeklyReviewReminder;

  constructor(initial: PlanningStateInitial) {
    this.myDayPlans = initial.myDayPlans;
    this.weeklyReview = initial.weeklyReview;
    this.inboxTriage = initial.inboxTriage;
    this.weeklyReviewReminder = initial.weeklyReviewReminder;
  }
}
